export const baseUrl='https://api.themoviedb.org/3'
export const API_KEY='aeebb7f8769b53b1200522ef6137f1f9'
export const imageUrl='https://image.tmdb.org/t/p/original'